
import {OPTION_CONSTANT} from '../_constants/Redux/OPTION_CONSTANT'
export const searchAction={
    saveSearchedFields,
}

function saveSearchedFields(data) {
    return { type:OPTION_CONSTANT.SEARCH_CHECHA,data } 
}